(ns frontend.view.grid.fundraising-opportunities-grid.events
  (:require
   [clojure.string :as string]
   [common.attribute :as attribute]
   [common.localization :as loc]
   [common.schema.entity-types :as entity-types]
   [common.schema.registry :as registry]
   [common.util :as cu]
   [frontend.actions.fundraising-opportunity :as fundraising-opportunity-actions]
   [frontend.actions.named-view :as named-view-actions]
   [frontend.conn :as conn]
   [frontend.local-storage :as ls]
   [frontend.logging :as logging]
   [frontend.react.virtualized.scrollable-grid.common :as grid]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.state.permissions :as f-permissions]
   [frontend.utils :as fu]
   [frontend.view.entity :as f-entity]
   [frontend.view.grid.fundraising-opportunities-grid.columns :as columns]
   [frontend.view.grid.fundraising-opportunities-grid.db :as db]
   [frontend.view.grid.investors-grid.events :as investors-events]
   [frontend.view.modals.confirmation.view :as confirmation]
   [frontend.view.modals.events :as modals]
   [frontend.zap-time :as zap-time]
   [potpuri.core :refer [fn->]]
   [promesa.core :as p]
   [reagent.core :as r]))

(defn system-views
  []
  [{:named-view/settings {:selected-columns columns/default-columns
                          :ordered-columns  columns/ordered-default-columns
                          :view-mode        :board-mode
                          :filters          {:fundraising-opportunity/status
                                             {:operand :operand/any-of
                                              :lower-bound-value
                                              #{:fundraising-opportunity.status/active}}}
                          :sort-by          :common/updated-on
                          :sort-direction   "DESC"}
    :named-view/name (loc/tr :active-pipeline)
    :disable-delete? true
    :db/id "named-view-fundraising-active-pipeline"}
   {:named-view/settings {:selected-columns columns/default-columns
                          :ordered-columns  columns/ordered-default-columns
                          :view-mode        :grid-mode}
    :named-view/name (loc/tr :all-fundraising-opportunities)
    :disable-delete? true
    :db/id "named-view-fundraising-all-opportunities"}
   {:named-view/settings {:selected-columns columns/my-fundraising-opportunities-columns
                          :ordered-columns  columns/my-fundraising-opportunities-ordered-columns
                          :view-mode        :grid-mode
                          :filters          {:fundraising-opportunity/owner
                                             {:operand :operand/any-of
                                              :lower-bound-value #{(:db/id @session/account)}}}}
    :named-view/name (loc/tr :my-fundraising-opportunities)
    :disable-delete? true
    :db/id "named-view-my-fundraising-opportunities"}

   {:named-view/settings {:selected-columns columns/lost-fundraising-opportunities-columns
                          :ordered-columns  columns/lost-fundraising-opportunities-ordered-columns
                          :view-mode        :grid-mode
                          :filters          {:fundraising-opportunity/status
                                             {:operand :operand/any-of
                                              :lower-bound-value
                                              #{:fundraising-opportunity.status/lost}}}
                          :sort-by          :fundraising-opportunity/lost-on
                          :sort-direction   "DESC"}
    :named-view/name (loc/tr :lost-fundraising-opportunities)
    :disable-delete? true
    :db/id "named-view-lost-fundraising-opportunities"}
   {:named-view/settings {:selected-columns columns/fundraising-opportunities-on-hold-columns
                          :ordered-columns  columns/fundraising-opportunities-on-hold-ordered-columns
                          :view-mode        :grid-mode
                          :filters          {:fundraising-opportunity/status
                                             {:operand :operand/any-of
                                              :lower-bound-value #{:fundraising-opportunity.status/on-hold}}}
                          :sort-by          :fundraising-opportunity/put-on-hold-on
                          :sort-direction   "DESC"}
    :named-view/name (loc/tr :fundraising-opportunities-on-hold)
    :disable-delete? true
    :db/id "named-view-fundraising-opportunities-on-hold"}
   {:named-view/settings
    {:selected-columns columns/new-fundraising-opportunities-this-q-columns
     :ordered-columns  columns/new-fundraising-opportunities-this-q-ordered-columns
     :view-mode        :grid-mode
     :filters          {:common/created-on {:operand :operand/on-or-after
                                            :lower-bound-value (fu/millis-start-of-this-q)}}
     :sort-by          :common/created-on
     :sort-direction   "DESC"}
    :named-view/name (loc/tr :new-fundraising-opportunities-this-q)
    :disable-delete? true
    :db/id "named-view-new-fundraising-opportunities-this-q"}])

(defn system-views-by-id
  []
  (->> (system-views)
       (map (fn [v]
              [(:db/id v) v]))
       (into {})))

(defn named-views
  []
  (concat (system-views)
          (->> @session/session
               :entities
               vals
               (cu/only-entity :entity.type/named-view)
               (cu/only-entity :named-view/view :fundraising-opportunities-grid)
               (sort-by :common/created-on))))

(defn named-view-by-id
  [id]
  (or (get @session/entities id)
      (get (system-views-by-id) id)))

(defn ls-path
  [& rest]
  (concat
   [(:db/id @session/account)
    (:db/id @session/tenant)
    :fundraising-opportunities-view-settings]
   rest))

(declare setup-column-state!)

(defn load-view!
  [named-view] ;;named-view entity
  (let [{:keys [named-view/settings]} named-view]
    (ls/set-in (ls-path) settings)
    (setup-column-state! settings)))

(defn save-current-view!
  [name]
  (let [settings @db/view-settings
        msg {:named-view/name     name
             :named-view/view     :fundraising-opportunities-grid
             :named-view/settings settings}]
    (named-view-actions/*create-named-view->
     msg
     identity
     (fn [& a] ;;TODO show error message
       (logging/error "create-named-view failed" a)))))

(defn get-label
  [k]
  (let [legal-entity-types (investors-events/current-legal-entity-types)
        ref-field? (vector? k)
        [_ investor-field legal-entity-field] (when (and (vector? k)
                                                         (= (first k)
                                                            :fundraising-opportunity/investor))
                                                k)]
    (cond
      (nil? k)
      nil

      (keyword k)
      (let [fs (registry/get-field-schema @session/tenant-schema k)]
        (loc/field-name k fs))

      (nil? legal-entity-field)
      (attribute/attribute-label @session/tenant-schema k)

      (and ref-field?
           (= (count legal-entity-types) 1)
           legal-entity-field)
      (loc/tr :investor-legal-entity-field [(loc/tr legal-entity-field)])

      (and ref-field?
           (> (count legal-entity-types) 1)
           (= (namespace legal-entity-field) "common"))
      (loc/tr :investor-legal-entity-field [(loc/tr legal-entity-field)])

      (and (keyword? legal-entity-field)
           (= (namespace legal-entity-field) "person"))
      (loc/tr :investor-legal-entity-specified-field [(loc/tr :person-lc) (loc/tr legal-entity-field)])

      (and (keyword? legal-entity-field)
           (contains? #{"company" "asset"} (namespace legal-entity-field)))
      (loc/tr :investor-legal-entity-specified-field [(loc/tr :company-lc) (loc/tr legal-entity-field)])

      :else
      (attribute/attribute-label @session/tenant-schema k))))

(defn precalculated-schema
  [recalculate?]
  (let [calculated @db/schema
        schema (cond
                 (and (not recalculate?)
                      calculated)
                 calculated
                 :else
                 (->>
                  (registry/get-schema @session/tenant-schema :entity.type/fundraising-opportunity)
                  (remove
                   (fn [[k v]]
                     (let [grid-visibility (->> v
                                                :field/default-visibility
                                                :grid)
                           pipeline @session/selected-froppo-pipeline
                           not-available?
                           (or (columns/not-available k)
                               (nil? grid-visibility)
                               (= grid-visibility :editor.type/none)
                               (if (or (not= (:field/data-type v) :data.type/currency-symbol)
                                       (not (:field/secondary-field? v)))
                                 (not (f-permissions/field-read-access?
                                       k
                                       :entity.type/fundraising-opportunity
                                       pipeline))
                                 (not (f-permissions/field-read-access?
                                       (:field/related-fields v)
                                       :entity.type/fundraising-opportunity
                                       pipeline))))]
                       not-available?)))
                  (sort-by (fn [[k v]]
                             (-> v
                                 :field/translations
                                 :en)))))
        investor-schema
        (when (or recalculate?
                  (not calculated))
          (->> (investors-events/precalculated-schema recalculate?)
               (map (fn [[k v :as u]]
                      [(if (vector? k)
                         (into [:fundraising-opportunity/investor] k)
                         [:fundraising-opportunity/investor k]) v]))
               (into {})
               (remove (fn-> first (= [:fundraising-opportunity/investor :investor/name])))
               (sort-by (fn [[_ v]]
                          (-> v
                              :field/translations
                              :en)))
               doall))
        schema (if (and (not recalculate?)
                        calculated)
                 schema
                 ;; 'get-label' above assumes investor fields are the only ref-fields.
                 ;;  if adding others, update get-label correspondingly
                 (concat schema investor-schema))]
    (when (or recalculate?
              (not calculated))
      (reset! db/schema schema))
    schema))

;;precalculate for performance reasons
(defn keys-and-schemas
  []
  (precalculated-schema false))

(defn fundraising-opportunity-column-keys
  []
  (concat
   (when (session/is-admin?) [:db/id])
   (map first (keys-and-schemas))))

(def default-kanban-attributes
  [:fundraising-opportunity/cur-commitment-amount
   :fundraising-opportunity/overview
   :fundraising-opportunity/description])

(defn visible-keys-and-schemas
  []
  (let [{:keys [attributes footer-1 footer-2]} @db/card-settings
        visible-attributes
        (set (concat @db/selected-columns
                     attributes
                     default-kanban-attributes
                     [footer-1 footer-2
                      (entity-types/type->owner-attribute :entity.type/fundraising-opportunity)]))]
    (->> (keys-and-schemas)
         (filter (fn [[k fs]]
                   (some #{k} visible-attributes))))))

(declare expanded? toggle-expand!)

(defn column-tabs
  []
  (let [legal-entity-types (investors-events/current-legal-entity-types)]
    (concat
     [{:key   :entity.type/fundraising-opportunity
       :label (loc/tr :opportunity)}
      {:key   :entity.type/investor
       :label (loc/tr :entity.type/investor)}]
     (when (= (count legal-entity-types) 1)
       [{:key   (first legal-entity-types)
         :label (loc/tr :legal-entity)}])
     (when (> (count legal-entity-types) 1)
       (concat
        [{:key   :entity.type/legal-entity
          :label (loc/tr :investor-legal-entity)}]
        (->> legal-entity-types
             (map (fn [et]
                    {:key   et
                     :label (loc/tr :investor-legal-entity-specified
                                [(-> (loc/tr et)
                                     str
                                     string/lower-case)])}))))))))

(defn resolve-tab
  [field]
  (let [ref-field? (vector? field)
        [_ investor-field legal-entity-field] (when ref-field?
                                                field)
        legal-entity-types (when ref-field?
                             (investors-events/current-legal-entity-types))]
    (cond
      (keyword? field)
      :entity.type/fundraising-opportunity

      (not (or (keyword? field)
               ref-field?))
      :unknown

      (nil? legal-entity-field)
      :entity.type/investor

      (and ref-field?
           (= (count legal-entity-types) 1))
      (first legal-entity-types)

      (and ref-field?
           (> (count legal-entity-types) 1)
           (= (namespace legal-entity-field) "common"))
      :entity.type/legal-entity

      (and ref-field?
           (> (count legal-entity-types) 1)
           (or (= (namespace legal-entity-field) "company")
               (= (namespace legal-entity-field) "asset")))
      :entity.type/company

      (and ref-field?
           (> (count legal-entity-types) 1)
           (= (namespace legal-entity-field) "person"))
      :entity.type/person

      :else :unknown)))

;;necessary arguments to use common grid functions
(defn setup-args
  []
  {:state                 db/fundraising-opportunities
   :entity-type           :entity.type/fundraising-opportunity
   :modal-state           db/modal-state
   :selected-columns-state db/selected-columns
   :ordered-columns-state db/ordered-columns
   :filters-state         db/fundraising-opportunity-filters
   :view-settings-state   db/view-settings
   :column-widths-state   db/column-widths
   :selected-pipeline     @session/selected-froppo-pipeline
   :ls-path               ls-path
   :containing-entity     (->> @session/selected-froppo-pipeline
                               (get @session/entities))
   :kanban-args           {:default-grouped-by  :fundraising-opportunity/opportunity-stage
                           :kanban-state        db/kanban
                           :grouped-by-state    db/grouped-by
                           :card-settings-state db/card-settings
                           ;;for long card view:
                           :default-attributes  default-kanban-attributes
                           :expanded-state      db/expanded
                           :sorted-kanban-entities-state db/sorted-kanban-entities
                           :lists-state         db/lists
                           :expanded?           expanded?
                           :toggle-expand!      toggle-expand!}
   :kanban?               true
   :column-keys           fundraising-opportunity-column-keys
   :column-tabs           (column-tabs)
   :resolve-tab           resolve-tab
   :default-columns       columns/default-columns
   :mandatory?            columns/mandatory?
   :visible-keys-and-schemas-fn visible-keys-and-schemas
   :custom-filters        {:fundraising-opportunity/pipeline
                           {:operand :operand/all-of
                            :lower-bound-value #{@session/selected-froppo-pipeline}}}})

(defn resolve-column-key-universe
  []
  (grid/resolve-column-key-universe (setup-args)))

(defn resolve-column-keys
  []
  (grid/resolve-column-keys (setup-args)))

(defn cleanup
  []
  (when-let [tracker (:tracker-1 @db/fundraising-opportunities)]
    (r/dispose! tracker))
  (when-let [tracker (:tracker-2 @db/fundraising-opportunities)]
    (r/dispose! tracker))
  (when-let [tracker (:tracker-3 @db/fundraising-opportunities)]
    (r/dispose! tracker))

  (swap! db/fundraising-opportunities dissoc
    :loaded
    :schema
    :entities
    :entity-types
    :view-settings
    :sorted-grid-entities
    :sorted-kanban-entities
    :search
    :kanban
    :selected
    :grid-entities))

(defn setup-column-state!
  [view-settings]
  (reset! db/view-settings view-settings)
  (when (nil? @db/selected-columns)
    (let [default-view-settings (->> (named-views)
                                     first
                                     :named-view/settings)]
      (reset! db/view-settings default-view-settings)
      (ls/set-in (ls-path) default-view-settings)))
  (grid/recalculate (assoc (setup-args) :re-sort? true)))

(defn fundraising-opportunities-updates
  []
  (let [fundraising-opportunities (->> @session/all-fundraising-opportunities
                                       (cu/filter-by :fundraising-opportunity/pipeline
                                                     @session/selected-froppo-pipeline))]
    (swap! db/fundraising-opportunities assoc :grid-entities fundraising-opportunities)))

(defn permission-updates
  []
  (let [current-permissions @session/current-permissions]
    (when current-permissions
      (precalculated-schema true))))

(defn trigger-recalculation
  []
  (let [permissions-trigger @db/schema
        entities-trigger @db/grid-entities]
    (when (or permissions-trigger entities-trigger)
      (fu/timeout 10
                  (fn []
                    (grid/recalculate (assoc (setup-args) :stale-sort? true))
                    (swap! db/fundraising-opportunities assoc :loaded true)
                    (deref db/fundraising-opportunities))))))

(defn setup
  [closed-atom?]
  (when-not @closed-atom?
    (if (empty? (ls/get-in (ls-path)))
      (load-view! (first (named-views)))
      (reset! db/view-settings (ls/get-in (ls-path))))
    (swap! db/fundraising-opportunities assoc
      :tracker-1 (r/track! fundraising-opportunities-updates)
      :tracker-2 (r/track! permission-updates)
      :tracker-3 (r/track! trigger-recalculation))
    (setup-column-state! (ls/get-in (ls-path)))))

(defn toggle-quick-filters!
  []
  (swap! db/fundraising-opportunities update :show-quick-filters? not))

(defn switch-mode!
  [current-mode]
  (let [new-mode (if (= current-mode :grid-mode) :board-mode :grid-mode)]
    (swap! db/view-settings assoc :view-mode new-mode)
    (ls/update-in (ls-path) assoc :view-mode new-mode)))

(defn mass-delete!
  []
  (-> (conn/sendp! :fundraising-opportunity/mass-action
                   {:action :delete-fundraising-opportunities
                    :fundraising-opportunity-ids (grid/get-selected-items (setup-args))})
      (p/then (fn [args]
                (swap! db/fundraising-opportunities assoc :selected {})))
      (p/catch (fn [e]
                 (logging/error "Unable to delete selected fundraising-opportunities" e)))))

(defn mass-apply-tags!
  [selected-tag]
  (-> (conn/sendp! :fundraising-opportunity/mass-action
                   {:action  :add-tag-to-all
                    :fundraising-opportunity-ids (grid/get-selected-items (setup-args))
                    :tag-ids (into [] selected-tag)})
      (p/then (fn [args]
                (swap! db/fundraising-opportunities assoc :selected {})))
      (p/catch (fn [e]
                 (logging/error "Unable to apply tags to selected fundraising-opportunities" e)))))

(defn mass-remove-tags!
  [selected-tags]
  (-> (conn/sendp! :fundraising-opportunity/mass-action
                   {:action  :remove-tags-from-all
                    :fundraising-opportunity-ids (grid/get-selected-items (setup-args))
                    :tag-ids (into [] selected-tags)})
      (p/then (fn [args]
                (swap! db/fundraising-opportunities assoc :selected {})))
      (p/catch (fn [e]
                 (logging/error "Unable to remove tags to selected fundraising-opportunities" e)))))

(defn open-selected!
  [_]
  (let [fundraising-opportunity-id (-> (grid/get-selected-items (setup-args))
                                       (first))]
    (routing/open-entity fundraising-opportunity-id)))

(defn delete-selected-clicked
  [_]
  (modals/open-modal!
   confirmation/modal-key
   {:body          [:div
                    [:p (loc/tr :confirm-delete-selected)]]
    :confirm-text  (loc/tr :confirm-delete-selected-button)
    :checkbox-text (loc/tr :confirm-delete-selected-checkbox)
    :on-confirm    mass-delete!}))

(defn expanded?
  [entity-id]
  (let [card-mode (or (:card-mode @db/kanban)
                      :short-card)
        individual (get @db/expanded entity-id)]
    (or (and (= card-mode :short-card)
             individual)
        (and (= card-mode :long-card)
             (not individual)))))

(defn toggle-expand!
  [entity-id]
  (let [expanded? (get @db/expanded entity-id)]
    (if expanded?
      (swap! db/expanded dissoc entity-id)
      (swap! db/expanded assoc entity-id true))))

(defn show-collapse-all?
  []
  (let [card-mode (or (:card-mode @db/kanban)
                      :short-card)
        individual-count (count @db/expanded)
        total-entity-count (count @db/sorted-kanban-entities)]
    (or (and (= card-mode :short-card)
             (> individual-count 0))
        (and (= card-mode :long-card)
             (< individual-count total-entity-count)))))

(defn expand-all!
  []
  (swap! db/kanban assoc :card-mode :long-card)
  (reset! db/expanded {}))

(defn collapse-all!
  []
  (swap! db/kanban assoc :card-mode :short-card)
  (reset! db/expanded {}))

(defn open-card-settings!
  []
  (swap! db/kanban assoc :card-settings? true))

(defn close-card-settings!
  []
  (swap! db/kanban dissoc :card-settings?))

(defn resurrect!
  [entity]
  (fundraising-opportunity-actions/*->resurrect!
   {:fundraising-opportunity-id (:db/id entity)}
   (fn [_])
   (fn [err]
     (logging/error "Failed to reactivate froppo " err))))

(defn won!
  [{:keys [entity reset-focus!]}]
  (let [fo-owner (:fundraising-opportunity/owner entity)
        fo-credit (:fundraising-opportunity/credit entity)]
    (f-entity/open-creator!
     :entity.type/fund-commitment
     (merge
      {:start-value   (merge
                       {:fund-commitment/investor (:fundraising-opportunity/investor entity)
                        :fund-commitment/cur-committed-amount
                        (:fundraising-opportunity/cur-commitment-amount entity)
                        :fund-commitment/cur-committed-amount--sym
                        (:fundraising-opportunity/cur-commitment-amount--sym entity)}

                       (when (f-permissions/field-write-access? :fund-commitment/owner
                                                                :entity.type/fund-commitment
                                                                nil)
                         {:fund-commitment/owner (or (session/active-account-id fo-owner)
                                                     (:db/id @session/account))})
                       (when (f-permissions/field-write-access? :fund-commitment/committed-date
                                                                :entity.type/fund-commitment
                                                                nil)
                         {:fund-commitment/committed-date (zap-time/now)})

                       (when (f-permissions/field-write-access? :fund-commitment/credit
                                                                :entity.type/fund-commitment
                                                                nil)
                         {:fund-commitment/credit (or (session/active-account-id fo-credit)
                                                      (session/active-account-id fo-owner)
                                                      (:db/id @session/account))})
                       (when (f-permissions/field-write-access? :fund-commitment/won-by
                                                                :entity.type/fund-commitment
                                                                nil)
                         {:fund-commitment/won-by (:db/id @session/account)})
                       (when-let [fund (or (:fundraising-opportunity/fund entity)
                                           (->> entity
                                                :fundraising-opportunity/pipeline
                                                (get @session/entities)
                                                :pipeline/fund))]
                         (when (f-permissions/field-write-access? :fund-commitment/fund
                                                                  :entity.type/fund-commitment
                                                                  nil)
                           {:fund-commitment/fund fund})))
       :on-processed! (fn [{:keys [new-entity-id close-cb!]}]
                        (fundraising-opportunity-actions/*->won!
                         {:fundraising-opportunity-id (:db/id entity)
                          :fund-commitment-id         new-entity-id}
                         (fn [_]
                           (close-cb!))
                         (fn [err]
                           (logging/error "Failed to set froppo as Won " err))))}
      (when reset-focus!
        {:reset-focus! reset-focus!})))))
